import React from 'react';
import { C } from '../constants/theme';

const variantStyles = {
  primary: { background: C.primary, color: C.white, border: 'none' },
  outline: { background: C.white, color: C.primary, border: `1.5px solid ${C.primary}` },
  danger: { background: C.danger, color: C.white, border: 'none' },
  ghost: { background: 'transparent', color: C.textMuted, border: `1px solid ${C.border}` },
};

export function Button({ children, onClick, variant = 'primary', small, disabled, type = 'button' }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        ...variantStyles[variant],
        borderRadius: 8,
        padding: small ? '6px 14px' : '9px 18px',
        fontSize: small ? 13 : 14,
        fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'all .15s',
        whiteSpace: 'nowrap',
        fontFamily: 'inherit',
      }}
    >
      {children}
    </button>
  );
}
